enum PurchaseTime {
  NotSpecified = 0,
  Asap = 1,
  NextMonth = 2,
  OnetoTwoMonths = 3,
  TwotoThreeMonths = 4,
  ThreetoSixMonths = 5,
  SixMonthsPlus = 6
}

export default PurchaseTime;
